import { useMemo } from "react";
import { useQuery } from "react-query";
import { getTodayAppointments } from "../../services/queue";
import { TodayAppointmentApi } from "../../services/queue/types";

/**
 * RDV du jour indexés par patient : badge « RDV HH:MM » et médecin pré-rempli
 * à l'ajout en file. Partagé par la page Patients et la liste d'attente.
 */
export function useTodayAppointments(): Map<number, TodayAppointmentApi> {
  const { data } = useQuery(["queue-today-appointments"], () => getTodayAppointments(), {
    staleTime: 30000,
  });
  return useMemo(() => {
    const appointments: TodayAppointmentApi[] = (data as any)?.data || [];
    return new Map(appointments.map((appointment) => [appointment.patientId, appointment]));
  }, [data]);
}

export default useTodayAppointments;
